import React, { useContext, useState } from "react";
import AnimationPopup from "../RenderCompnent/AnimationPopup";
import { PropertyContext } from "../../../contexts/PropertyContext";

const IframeProperties = ({ selectedIframe, handleChange, searchTerm }) => {
  const [isAnimationPopupOpen, setIsAnimationPopupOpen] = useState(false);
  const {
    renderMarginProperties,
    renderPaddingProperties,
    renderBorderProperties,
    renderPositionProperties,
    renderHoveredMarginProperties,
    renderFocusedMarginProperties,
    renderActivatedMarginProperties,
    renderHoveredPaddingProperties,
    renderFocusedPaddingProperties,
    renderActivatedPaddingProperties,
    renderHoveredBorderProperties,
    renderFocusedBorderProperties,
    renderActivatedBorderProperties,
    renderHoveredPositionProperties,
    renderFocusedPositionProperties,
    renderActivatedPositionProperties,
  } = useContext(PropertyContext);

  const renderAnimationButton = () => {
    if (searchTerm && !"animation".includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div style={styles.inputGroup}>
        <button
          onClick={() => setIsAnimationPopupOpen(true)}
          style={styles.animationButton}
        >
          Open Animation Editor
        </button>
      </div>
    );
  };
  const renderInput = (label, name, type = "text", additionalProps = {}) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <input
          type={type}
          name={name}
          value={selectedIframe ? selectedIframe[name] : ""}
          onChange={handleChange}
          style={styles.input}
          {...additionalProps}
        />
      </div>
    );
  };
  const renderSelect = (label, name, options) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div key={name} style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <select
          name={name}
          value={selectedIframe ? selectedIframe[name] : ""}
          onChange={handleChange}
          style={styles.select}
        >
          <option value="">Select</option>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  };
  const renderMutableInput = (label, name, array) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div key={name} style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <div style={styles.widthHeightInputGroup}>
          <select
            name={name}
            value={selectedIframe ? selectedIframe[name] : ""}
            onChange={handleChange}
            style={styles.select}
          >
            {array.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <input
            type="text"
            name={name}
            value={selectedIframe ? selectedIframe[name] : ""}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
      </div>
    );
  };

  return (
    <div style={styles.container}>
      {renderInput("Source", "sourceIframe")}
      {renderInput("Title", "tilteForFrame")}

      {renderMutableInput("Width", "width", [
        "auto",
        "fit-content",
        "max-content",
        "min-content",
      ])}
      {renderMutableInput("Height", "height", [
        "auto",
        "fit-content",
        "max-content",
        "min-content",
      ])}
      {renderMarginProperties(renderMutableInput)}
      {renderPaddingProperties(renderMutableInput)}
      {renderBorderProperties(renderMutableInput, renderInput, renderSelect)}
      {renderPositionProperties(renderMutableInput, renderInput, renderSelect)}

      {renderMutableInput("Box Shadow", "boxShadow", [
        "none",
        "2px 4px 10px #000000",
      ])}
      {renderInput("Opacity", "opacity", "number", {
        min: 0,
        max: 1,
        step: 0.01,
      })}
      {renderSelect("Box Sizing", "boxSizing", ["content-box", "border-box"])}
      {renderSelect("Display", "display", ["inline", "inline-block", "block"])}
      {renderSelect("Visibility", "visibility", [
        "visible",
        "hidden",
        "collapse",
        "inherit",
        "initial",
        "unset",
      ])}
      {renderSelect("Cursor Type", "cursor", [
        "default",
        "pointer",
        "text",
        "move",
        "wait",
        "help",
        "not-allowed",
        "crosshair",
        "cell",
        "vertical-text",
        "alias",
        "copy",
        "no-drop",
        "grab",
        "grabbing",
        "e-resize",
        "n-resize",
        "ne-resize",
        "nw-resize",
        "s-resize",
        "se-resize",
        "sw-resize",
        "w-resize",
        "ns-resize",
        "ew-resize",
        "nesw-resize",
        "nwse-resize",
        "zoom-in",
        "zoom-out",
        "all-scroll",
      ])}
      {renderAnimationButton()}
      <AnimationPopup
        isOpen={isAnimationPopupOpen}
        onClose={() => setIsAnimationPopupOpen(false)}
        selectedDiv={selectedIframe}
        handleChange={handleChange}
      />
      {renderSelect("Pseudo Classes", "pseudoClass", [
        "none",
        "hover",
        "focus",
        "active",
      ])}
      {selectedIframe && selectedIframe.pseudoClass === "hover" && (
        <>
          {/* {renderMutableInput("Width Hover", "hoveredwidth", [
            "auto",
            "fit-content",
            "max-content",
            "min-content",
            "100%",
            "100vw",
          ])}
          {renderMutableInput("Height Hover", "hoveredheight", [
            "auto",
            "fit-content",
            "max-content",
            "min-content",
            "100%",
            "100vh",
          ])} */}
          {renderHoveredMarginProperties(renderMutableInput)}
          {renderHoveredPaddingProperties(renderMutableInput)}
          {renderHoveredBorderProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderHoveredPositionProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderMutableInput("Box Shadow Hover", "hoveredboxShadow", [
            "none",
            "2px 4px 10px #000000",
          ])}
          {renderInput("Opacity Hover", "hoveredOpacity", "number", {
            min: 0,
            max: 1,
            step: 0.01,
          })}

          {renderSelect("Cursor Hover", "hoveredcursor", [
            "default",
            "pointer",
            "text",
            "move",
            "wait",
            "help",
            "not-allowed",
            "crosshair",
            "cell",
            "vertical-text",
            "alias",
            "copy",
            "no-drop",
            "grab",
            "grabbing",
            "e-resize",
            "n-resize",
            "ne-resize",
            "nw-resize",
            "s-resize",
            "se-resize",
            "sw-resize",
            "w-resize",
            "ns-resize",
            "ew-resize",
            "nesw-resize",
            "nwse-resize",
            "zoom-in",
            "zoom-out",
            "all-scroll",
          ])}
          {renderSelect("Visibility Hover", "hoveredvisibility", [
            "visible",
            "hidden",
            "collapse",
            "inherit",
            "initial",
            "unset",
          ])}
        </>
      )}
      {selectedIframe && selectedIframe.pseudoClass === "focus" && (
        <>
          {/* {renderMutableInput("Width Focus", "focusedwidth", [
            "auto",
            "fit-content",
            "max-content",
            "min-content",
            "100%",
            "100vw",
          ])}
          {renderMutableInput("Height Focus", "focusedheight", [
            "auto",
            "fit-content",
            "max-content",
            "min-content",
            "100%",
            "100vh",
          ])} */}
          {renderFocusedMarginProperties(renderMutableInput)}
          {renderFocusedPaddingProperties(renderMutableInput)}
          {renderFocusedBorderProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderFocusedPositionProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderMutableInput("Box Shadow Focus", "focusedboxShadow", [
            "none",
            "2px 4px 10px #000000",
          ])}
          {renderInput("Opacity Focus", "focusedOpacity", "number", {
            min: 0,
            max: 1,
            step: 0.01,
          })}
          {renderSelect("Cursor Focus", "focusedcursor", [
            "default",
            "pointer",
            "text",
            "move",
            "wait",
            "help",
            "not-allowed",
            "crosshair",
            "cell",
            "vertical-text",
            "alias",
            "copy",
            "no-drop",
            "grab",
            "grabbing",
            "e-resize",
            "n-resize",
            "ne-resize",
            "nw-resize",
            "s-resize",
            "se-resize",
            "sw-resize",
            "w-resize",
            "ns-resize",
            "ew-resize",
            "nesw-resize",
            "nwse-resize",
            "zoom-in",
            "zoom-out",
            "all-scroll",
          ])}
          {renderSelect("Visibility Focus", "focusedvisibility", [
            "visible",
            "hidden",
            "collapse",
            "inherit",
            "initial",
            "unset",
          ])}
        </>
      )}
      {selectedIframe && selectedIframe.pseudoClass === "active" && (
        <>
          {/* {renderMutableInput("Width Active", "activatedwidth", [
            "auto",
            "fit-content",
            "max-content",
            "min-content",
            "100%",
            "100vw",
          ])}
          {renderMutableInput("Height Active", "activatedheight", [
            "auto",
            "fit-content",
            "max-content",
            "min-content",
            "100%",
            "100vh",
          ])} */}
          {renderActivatedMarginProperties(renderMutableInput)}
          {renderActivatedPaddingProperties(renderMutableInput)}
          {renderActivatedBorderProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderActivatedPositionProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderMutableInput("Box Shadow Active", "activatedboxShadow", [
            "none",
            "2px 4px 10px #000000",
          ])}
          {renderInput("Opacity Active", "activatedOpacity", "number", {
            min: 0,
            max: 1,
            step: 0.01,
          })}
          {renderSelect("Cursor Active", "activatedcursor", [
            "default",
            "pointer",
            "text",
            "move",
            "wait",
            "help",
            "not-allowed",
            "crosshair",
            "cell",
            "vertical-text",
            "alias",
            "copy",
            "no-drop",
            "grab",
            "grabbing",
            "e-resize",
            "n-resize",
            "ne-resize",
            "nw-resize",
            "s-resize",
            "se-resize",
            "sw-resize",
            "w-resize",
            "ns-resize",
            "ew-resize",
            "nesw-resize",
            "nwse-resize",
            "zoom-in",
            "zoom-out",
            "all-scroll",
          ])}
          {renderSelect("Visibility Active", "activatedvisibility", [
            "visible",
            "hidden",
            "collapse",
            "inherit",
            "initial",
            "unset",
          ])}
        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "5px",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    overflow: "hidden",
  },
  heading: {
    fontSize: "15px",
    margin: "10px 0",
    color: "#333",
    borderBottom: "1px solid #ccc",
    paddingBottom: "5px",
  },
  inputGroup: {
    margin: "10px 0",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "3px 5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  select: {
    width: "100%",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  filterInputGroup: {
    display: "flex",
    gap: "10px",
  },
  button: {
    marginTop: "5px",
    padding: "8px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  imageSelector: {
    marginTop: "10px",
  },
  animationButton: {
    width: "100%",
    padding: "10px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default IframeProperties;
